import { createSlice } from "@reduxjs/toolkit";

export const rewardReducer = createSlice({
  name: "reward",
  initialState: {
    rewards: [],
    rewardSearchResults: [],
  },
  reducers: {
    setRewards: (state, action) => {
      state.rewards = action.payload;
      state.rewardSearchResults = action.payload;
    },
    updateReward: (state, action) => {
      const index = state.rewards.findIndex(
        (reward) => reward.rewardId === action.payload.rewardId
      );
      state.rewards[index] = action.payload;
      state.rewardSearchResults = state.rewards;
    },
    deleteRewardReducer: (state, action) => {
      state.rewards = state.rewards.filter(
        (reward) => Number(reward.rewardId) !== Number(action.payload)
      );
      state.rewardSearchResults = state.rewards;
    },
    addNewReward: (state, action) => {
      state.rewards = [action.payload, ...state.rewards];
      state.rewardSearchResults = state.rewards;
    },
    searchRewards: (state, action) => {
      const query = action.payload.toLowerCase();
      state.rewardSearchResults = state.rewards.filter((reward) =>
        reward.rewardName.toLowerCase().includes(query)
      );
    },
    // sort rewards
    sortRewards: (state, action) => {
      const sortOption = action.payload;
      if (sortOption === "Name (A-Z)") {
        state.rewardSearchResults.sort((a, b) =>
          a.rewardName.toString().localeCompare(b.rewardName)
        );
      } else if (sortOption === "Name (Z-A)") {
        state.rewardSearchResults.sort((a, b) =>
          b.rewardName.toString().localeCompare(a.rewardName)
        );
      } else if (sortOption === "Last Modified") {
        state.rewardSearchResults.sort(
          (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
        );
      }
    },
    clearRewardSearch: (state) => {
      state.rewardSearchResults = state.rewards;
    },
  },
});

export const {
  setRewards,
  updateReward,
  deleteRewardReducer,
  addNewReward,
  searchRewards,
  sortRewards,
  clearRewardSearch,
} = rewardReducer.actions;

export default rewardReducer.reducer;
